<template>
  <landing-page
    label="workWithUs.workWithUs"
    description="workWithUs.workWithUsDesc"
    labelColor="#603813"
    descColor="#603813"
    :eggImgObj="{ componentName: 'workWithUs', imgName: 'workWithUsIntro', imgFormat: 'png' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }"
    class="mb-10"
  />
</template>

<script setup lang="ts">
import { useWorkWithUsStore } from "@/stores/workWithUs";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const workWithUsStore = useWorkWithUsStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>